'use client';
import Image from 'next/image';
import { useRouter, useSearchParams } from 'next/navigation';
import { withReactSuspense } from '@/shared/hocs/withReactSuspense';
import SearchIconImage from './icon_search_white.svg?url';

export const SearchBoxForBigBar: React.FC = withReactSuspense(() => {
  const params = useSearchParams();
  const router = useRouter();

  return (
    <form
      action=""
      method="get"
      onSubmit={(event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const form = new FormData(event.currentTarget);
        const searchQuery = form.get('searchQuery');
        if (!searchQuery) {
          return;
        }
        router.push(`/guide/search?q=${searchQuery}`);
      }}
    >
      <div className="grid h-12 grid-cols-[1fr_auto] overflow-hidden rounded-[1.5rem] border-2 border-base-100 bg-base-100">
        <div>
          <input
            type="text"
            name="searchQuery"
            placeholder="例) 再生、パスワード、解約方法"
            defaultValue={params?.get('q') ?? ''}
            className="size-full border-none px-4 outline-hidden"
          />
        </div>
        <div>
          <button
            className="relative h-full w-12 overflow-hidden bg-main-80"
            type="submit"
          >
            <Image
              src={SearchIconImage}
              alt=""
              className="absolute inset-0 m-auto size-6"
            />
          </button>
        </div>
      </div>
    </form>
  );
});
